// extracted by mini-css-extract-plugin
export default {"rtlTransform":"utils_rtlTransform__JZwSV","large":"utils_large__ZfK-m"};